import ArticleCard from "./ArticleCard";

export default function RelatedArticles({ articles = [], basePath = "/guides", title = "Related reading" }) {
  if (!articles.length) return null;
  return (
    <section className="mt-20" data-testid="related-articles">
      <div className="flex items-end justify-between mb-8">
        <h2 className="font-playfair text-2xl sm:text-3xl text-neutral-900 tracking-tight">
          {title}
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
        {articles.map((a, i) => (
          <ArticleCard
            key={a.id || a.slug}
            article={a}
            basePath={a.type === "review" ? "/reviews" : "/guides"}
            index={i}
          />
        ))}
      </div>
    </section>
  );
}
